/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    a: "a"
  }, _provideComponents(), props.components);
  return React.createElement(_components.p, null, "In addition to the free London walk on 20th February, Frank Molloy is leading an additional walk on the afternoon of Sunday 23rd February, in association with the ", React.createElement(_components.a, {
    href: "https://terminaliafestival.org/"
  }, "Psychogeography Terminalia festival"), ". Unlike the earlier walk, this is a ticketed event with a limited number of spaces that must be booked in advance from ", React.createElement(_components.a, {
    href: "https://www.eventbrite.co.uk/e/terminalia-2025-arthur-machen-walk-tickets-1208674490939"
  }, "EventBrite"), ".");
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
